/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Model_RalColorGet } from '../models/Model_RalColorGet';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RalColorService {
    /**
     * @returns Model_RalColorGet Success
     * @throws ApiError
     */
    public static getApiV1RalColors(): CancelablePromise<Array<Model_RalColorGet>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/ralColors',
        });
    }
}
